import React, { useEffect, useState } from "react"
import clsx from "clsx"
import API from "../../api"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import Button from "../button"
import TextInputField from "../textInput"
import Tippy from "@tippyjs/react"
import { useLanguage } from "@languages/index"

interface Props {
  className?: string
  onClick?: any
  style?: any

  applicant?: any
  brand?: any
  onUpdate?: any

  isShoes?: boolean
  isUnderwear?: boolean

  auth?: any
  showModal?: (params?: any) => void
  preferences?: any
}

const CampaignApplicantItem = (props: Props) => {
  const language = useLanguage()
  const languageTexts = {
    ...language.common,
    ...language.component.campaignApplicantItem,
  }

  let className = clsx("campaign-applicant", `${props.className}`)

  const [trackingNumber, setTrackingNumber] = useState(props.applicant.trackingNumber ?? "")

  const formatKoreanPhoneNumber = (number) => {
    const formatted = number.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")
    return formatted
  }

  const storeTrackingNumber = async () => {
    try {
      const response = await API.Rent.storeTrackingNumber({
        brandToken: props.auth.token,
        applicantId: props.applicant.id,
        trackingNumber: trackingNumber,
      })

      props.showModal({ text: response.message })
      props.onUpdate ? props.onUpdate(response.data.applicant) : null
    } catch (error) {
      props.showModal({ text: error.message })
    }
  }

  const storePrepareDt = () => {
    props.showModal({
      title: !props.applicant.isPrepared ? languageTexts.modal_title_1 : languageTexts.modal_title_2,
      text: !props.applicant.isPrepared ? languageTexts.modal_text_1 : languageTexts.modal_text_2,
      cancel: () => {},
      confirm: async () => {
        try {
          if (!props.applicant.isPrepared) {
            await storeTrackingNumber()
          }

          const response = await API.Rent.storePrepareDt({
            brandToken: props.auth.token,
            applicantId: props.applicant.id,
          })

          props.showModal({ text: response.message })
          props.onUpdate ? props.onUpdate(response.data.applicant) : null
        } catch (error) {
          props.showModal({ text: error.message })
        }
      },
    })
  }

  const renderInstagramLinkIcon = () => {
    return (
      <img
        className="w-4 h-4 cursor-pointer"
        onClick={() => {
          window.open(
            `https://instagram.com/` +
              `${props.applicant.user.userModel.instaUserId}` +
              `${props?.brand?.isCategoryBeauty ? "/reels/" : ""}`,
            "_blank"
          )
        }}
        src={`/assets/icons/ic-instagram-sm.svg`}
      />
    )
  }

  return (
    <div className={className} style={props.style ? props.style : {}}>
      <div className="flex flex-row md:items-center">
        <div className="shrink-0 w-[38px] h-[38px] rounded-full overflow-hidden mr-3">
          <img className="w-full h-full" src={`${props.applicant.user.profileImageUrl}`} />
        </div>

        <div className="grid items-center gap-3 md:grid-flow-col md:grid-cols-7 w-ufll">
          <div className="flex flex-col gap-1">
            <div className="flex flex-row w-full md:w-auto items-center">
              <div className="flex flex-col">
                <div className="flex flex-row items-center">
                  <span className="text-sm tracking-tighter mr-1">{props.applicant.user.username}</span>
                  {props?.brand?.isCategoryBeauty ? (
                    renderInstagramLinkIcon()
                  ): null}
                </div>
                {props.applicant.user.usernameEn ? (
                  <span className="text-sm tracking-tighter mr-1">({props.applicant.user.usernameEn})</span>
                ) : null}
                {!props?.brand?.isCategoryBeauty ? (
                  <>
                    <div className="flex flex-row">
                    <img className="mr-1 w-3 h-3" src={`/assets/icons/ic-star-gold.svg`} />
                    <span className="text-xs  tracking-tighter mr-2">
                      {props.applicant.user.userModel.averageRatingsByAdmin
                        ? props.applicant.user.userModel.averageRatingsByAdmin.toFixed(1)
                        : "0.0"}
                    </span>
                    {renderInstagramLinkIcon()}
                  </div>
                  </>
                ) : null}
              </div>
            </div>
            {!props?.brand?.isCategoryBeauty ? (
              <div className="flex flex-row gap-1 w-full md:w-auto items-center">
                <span className="text-xs tracking-tighter opacity-50">
                  {languageTexts._modelSizeLine0(props.applicant.user.userModel.age)}
                </span>

                {props.brand.isCategoryFashion ? (
                  <span className="text-xs tracking-tighter opacity-50">
                    {languageTexts._modelSizeLine1(
                      props.applicant.user.userModel.topSize,
                      props.applicant.user.userModel.bottomSize
                    )}
                  </span>
                ) : null}

                {props.isUnderwear &&
                props.applicant.user.userModel.braSize &&
                props.applicant.user.userModel.pantieSize ? (
                  <span className="text-xs tracking-tighter opacity-50">
                    {languageTexts._modelSizeLine2(
                      props.applicant.user.userModel.braSize,
                      props.applicant.user.userModel.pantieSize
                    )}
                  </span>
                ) : null}
                {props.isShoes && props.applicant.user.userModel.shoesSize ? (
                  <span className="text-xs tracking-tighter opacity-50">
                    {languageTexts._modelSizeLine3(props.applicant.user.userModel.shoesSize)}
                  </span>
                ) : null}
              </div>
            ) : null}
            <div className="text-sm tracking-tighter">{formatKoreanPhoneNumber(props.applicant.user.mobile)}</div>
          </div>

          <div className="flex flex-col md:col-span-4 gap-3">
            <div className="flex text-left flex-col text-sm tracking-tighter gap-[4px]">
              <span>
                {`(${props.applicant.user.userModel.zoneCode}) ${props.applicant.user.userModel.address} ${props.applicant.user.userModel.addressDetail}`}
              </span>
            </div>

            {props.applicant.user.userModel.addressEn || props.applicant.user.userModel.addressDetailEn ? (
              <div className="flex text-left flex-col text-sm tracking-tighter gap-[4px]">
                <span>
                  {`(${props.applicant.user.userModel.zoneCode}) ${props.applicant.user.userModel.addressEn ?? ""} ${
                    props.applicant.user.userModel.addressDetailEn ?? ""
                  }`}
                </span>
              </div>
            ) : null}

            <span>{props.applicant.user.userModel.deliveryMsg}</span>
          </div>

          <div className="relative inline-flex flex-row flex-nowrap shrink-0 items-center gap-2 md:col-span-2">
            <div
              className={clsx({
                "min-w-[125px] h-[46px]": !props.preferences.isMobile,
                "grow-0 min-w-[105px] h-[37px]": props.preferences.isMobile,
              })}
            >
              <TextInputField
                className="inline-flex h-full"
                height="100%"
                placeholder={languageTexts.input_tracking_num}
                numbersOnly={false}
                onChangeText={(value: any) => {
                  setTrackingNumber(value)
                }}
                value={trackingNumber ? trackingNumber : ""}
                button={{
                  condition: "on-focus",
                  position: "right",
                  button: () => {
                    return (
                      <div className="absolute top-0 bottom-0 -left-[50px] w-[50px] flex items-center pr-1">
                        <Button
                          className={"rounded px-3 py-2"}
                          text={languageTexts.save}
                          textClassName={"text-sm tracking-tighter"}
                          textColor="WHITE"
                          borderColor={"BLACK"}
                          buttonColor={"BLACK"}
                          onClick={() => {
                            storeTrackingNumber()
                          }}
                        />
                      </div>
                    )
                  },
                }}
              />
            </div>

            {props.applicant.isPrepared && (
              <div
                className="inline-flex justify-center text-xs text-center py-3 px-4 cursor-pointer whitespace-nowrap"
                onClick={() => {
                  storePrepareDt()
                }}
              >
                {languageTexts.prepared2}
              </div>
            )}

            {!props.applicant.isPrepared && (
              <Button
                className={clsx("inline-flex justify-center text-xs text-center py-3 px-4 w-auto md:min-w-28", {
                  "grow-0": props.preferences.isMobile,
                })}
                textColor={"WHITE"}
                buttonColor={"BLACK"}
                textClassName={"text-sm"}
                text={languageTexts.prepared}
                onClick={() => {
                  storePrepareDt()
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(CampaignApplicantItem)
